import { render, staticRenderFns } from "./FAQCollectStamp.vue?vue&type=template&id=092867d2&scoped=true"
import script from "./FAQCollectStamp.vue?vue&type=script&lang=js"
export * from "./FAQCollectStamp.vue?vue&type=script&lang=js"
import style0 from "./FAQCollectStamp.vue?vue&type=style&index=0&id=092867d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092867d2",
  null
  
)

export default component.exports